module.exports = __webpack_public_path__ + "img/live-cast-img02.7f2eee8f.png";